// Copyright (c) 2026 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { getTriageCustomers } from '@/customer/api/triage-get-customers';
import { CustomerTriageFilter } from '@/customer/api/triage-types';
import { triageCustomerListQueryKey } from '@/customer/triage-query-keys';
import { useSuspenseQuery } from '@tanstack/react-query';

interface UseTriageCustomersOptions {
  filter?: CustomerTriageFilter;
}

export function useTriageCustomers(options: UseTriageCustomersOptions = {}) {
  const { data, ...query } = useSuspenseQuery({
    queryKey: triageCustomerListQueryKey(options.filter),
    queryFn: () => getTriageCustomers(options.filter),
    refetchOnWindowFocus: true,
  });

  return { customers: data.customers, resultCount: data.totalCount, ...query };
}
